<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!TreatmentId">Adding Treatment</span>
                <span *ngIf="TreatmentId">Update Treatment</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="treatmentForm" (submit)="createTreatment()">

                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4 col-lg-4">
                                <label class="form-label">Treatment Category *</label>
                                <mat-select  placeholder="Category" formControlName="catergory_id" [ngClass]="{'readOnly': myrole=='6'}">
                                    <mat-option [value]="cat.id" *ngFor="let cat of treatCategory">{{cat.name}}</mat-option>
                                </mat-select>
                                <div *ngIf="submitted && f.catergory_id.errors" class="invalid-feedback">
                                    <div *ngIf="f.catergory_id.errors.required">Category is required</div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4 right-border">
                                <div class="form-group">
                                    <label class="form-label">Treatment Name *</label>
                                    <input type="text" placeholder="Treatment Name" formControlName="name" class="form-control" [ngClass]="{'readOnly': myrole=='6'}" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Treatment Name is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <label class="form-label">Status *</label>
                                <mat-select  placeholder="Status" formControlName="status" [ngClass]="{'readOnly': myrole=='6'}">
                                    <mat-option [value]="1">Active</mat-option>
                                    <mat-option [value]="0">In-Active</mat-option>

                                </mat-select>
                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                    <div *ngIf="f.status.errors.required">Status is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4 col-lg-4 right-border">
                            <div class="form-group">
                              <label class="form-label">Upload  Treatment Image</label>
                              <input type="file" (change)="selectProfilePic($event)" class="form-control" />
                            </div>
                           </div>
                           <div class="col-md-8 col-lg-8 right-border">
                            <div class="form-group">
                                <label class="form-label">Treatment Description *</label>
                                <textarea placeholder="Treatment Description" formControlName="description" class="form-control" ></textarea>
                                <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                    <div *ngIf="f.description.errors.required">Treatment Description is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="form-label">Available City</label>
                                <mat-select  placeholder="City" formControlName="available_cities" (click)="setSearchValue()" multiple [sortComparator]='sortFunc'>
                                    <input class="mySearchInput"
                                    #citySearch focused="'true'" type="text"
                                    (keyup)="searchOnSelect($event.target.value, 'city')"
                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                    placeholder="Search"
                                    id="citySearch">
                                    <mat-option [value]="city.city_id" *ngFor="let city of cities" >{{city.name}}</mat-option>
                                </mat-select>
                               
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                         <span *ngIf="!TreatmentId">Create Treatment</span>
                        <span *ngIf="TreatmentId">Update Treatment</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
